<template>
  <div class="course-calendar">
    <table>
      <caption>
        <coach-select :value="coach" style="width:120px" @input="coachInput" />
        <i class="el-icon-arrow-left arrow-btn" @click="prevWeek"></i>
        <el-date-picker :editable="false" :clearable="false" @input="pickerChange" :value="date" type="date" placeholder="选择日期" style="width:120px;">
        </el-date-picker>
        <i class="el-icon-arrow-right arrow-btn" @click="nextWeek"></i>
      </caption>
      <thead>
        <tr>
          <th>
            <h3>开课时间</h3>
          </th>
          <th v-for="item in dates" :key="item.format('YYYY-MM-DD')">
            <h3>{{item.weekday()|weekFormat}}</h3>
            <p>({{item.format('YYYY-MM-DD')}})</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in 24" v-bind:key="row">
          <td>
            {{(row-1) + ":00"}} </td>
          <td v-for="col in 7" v-bind:key="col">
            <div v-for="c in getCourses(col-1,row-1)" @click="courseClick(c.id)" v-bind:key="c.id" :class="{'cursor-pointer':clickable}" :style="personal?{}:{'background-color':hexToRgba(c.color),'border-color':c.color}">
              <p class="time">
                {{c.scheduleTime}}
              </p>
              <p class="coach">
                {{c.trainerName}}
              </p>
              <p class="course">
                {{c.courseName}}
              </p>
              <p :class="{member:personal,groupmember:!personal}">
                {{personal?c.memberName:(c.reservation+" / "+c.personalMax+' 人')}}
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Moment from 'moment'

export default {
  data () {
    return {
      startDate: null,
      endDate: null,
      dates: [],
      courses: []
    }
  },
  created: function () {
    this.initDate()
  },
  methods: {
    initDate () {
      let currDate = new Moment(this.date)
      let weekday = currDate.weekday()
      this.startDate = currDate.clone().add(-weekday, 'day')
      this.endDate = this.startDate.clone().add(7, 'day')
      this.dates.length = 0
      for (let i = 0; i < 7; i++) {
        this.dates.push(this.startDate.clone().add(i, 'day'))
      }
      this.fetchDate()
    },
    getCourses (days, hours) {
      let currDate = this.startDate.clone()
      currDate.add(days, 'days')
      currDate.add(hours, 'hours')
      let key = currDate.format('YYYY-MM-DD HH')
      return this.courses[key]
    },
    fetchDate () {
      if (this.fetchCourses) {
        let params = {
          beginDate: this.startDate.format('YYYY-MM-DD 00:00:00'),
          endDate: this.endDate.format('YYYY-MM-DD 00:00:00'),
          trainerId: this.coach
        }
        let that = this
        this.fetchCourses(params, function (courseList) {
          that.courses = []
          for (let i = 0; i < courseList.length; i++) {
            let key = new Moment(courseList[i].scheduleDate + ' ' + courseList[i].scheduleStartTime).format('YYYY-MM-DD HH')
            if (!that.courses[key]) { that.courses[key] = [] }
            that.courses[key].push(courseList[i])
          }
        })
      }
    },
    nextWeek () {
      var currDate = new Moment(this.date)
      currDate.add(7, 'days')
      this.routeTo(currDate)
    },
    prevWeek () {
      var currDate = new Moment(this.date)
      currDate.add(-7, 'days')
      this.routeTo(currDate)
    },
    pickerChange (newValue) {
      var currDate = new Moment(newValue)
      this.routeTo(currDate)
    },
    routeTo (tDate) {
      let params = Object.assign({}, this.$route.query)
      if (tDate) { params.date = tDate.format('YYYY-MM-DD') }
      this.$router.replace({ query: params })
    },
    coachInput (newValue) {
      let params = Object.assign({}, this.$route.query)
      if (newValue) { params.coach = newValue } else { delete params.coach }
      this.$router.replace({ query: params })
    },
    courseClick (id) {
      if (!this.clickable) return
      this.$router.push({ path: 'view', query: { id: id } })
    },
    hexToRgba (hex) {
      if (hex) { return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + 0.3 + ')' }
    }
  },
  watch: {
    'date': 'initDate',
    'coach': 'fetchDate'
  },
  props: {
    fetchCourses: { type: Function, required: true },
    clickable: { type: Boolean, default: true },
    personal: { type: Boolean, default: false }
  },
  computed: {
    date: function () {
      let date = this.$route.query.date
      if (!date) { date = new Moment().format('YYYY-MM-DD') }
      return date
    },
    coach: function () {
      let coach = this.$route.query.coach
      return coach
    }
  },
  filters: {
    timeFormat (dateValue) {
      return new Moment(dateValue).format('HH:mm')
    },
    weekFormat (week) {
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][week]
    }
  }
}
</script>
<style scoped>
.course-calendar {
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

table caption {
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  color: #8492a6;
}

table caption .arrow-btn {
  border: 1px solid;
  border-radius: 13px;
  padding: 3px;
  cursor: pointer;
}

table thead {
  border: 2px solid #eaeaea;
  background: #f8f8f8;
}

table thead th {
  width: 12.5%;
  height: 50px;
}

table thead th h3 {
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  color: #444;
  font-size: 15px;
  font-weight: bold;
}

table thead th p {
  padding: 0px;
  margin: 0px;
  line-height: 15px;
  color: #aaa;
  font-size: 12px;
  font-weight: normal;
}

table tbody td {
  border: 2px solid #eaeaea;
  width: 12.5%;
  height: 50px;
  padding: 2px;
}

table tbody td div {
  text-align: left;
  border: 1px solid #eb9595;
  border-top-width: 3px;
  border-radius: 5px;
  color: #888;
  margin-bottom: 5px;
  padding: 4px;
  background: rgba(235, 149, 149, 0.3)
}

.cursor-pointer {
  cursor: pointer;
}

table tbody td p {
  line-height: 22px;
  font-size: 12px;
  margin: 0px;
  text-indent: 22px;
}

table tbody td p.time {
  background: url(../../assets/icons/time.png) left center no-repeat;
}

table tbody td p.coach {
  background: url(../../assets/icons/coach1.png) left center no-repeat;
}

table tbody td p.course {
  background: url(../../assets/icons/sortsmall.png) left center no-repeat;
}

table tbody td p.member {
  background: url(../../assets/icons/privatemember.png) left center no-repeat;
}
table tbody td p.groupmember {
  background: url(../../assets/icons/groupmember.png) left center no-repeat;
}
</style>




// WEBPACK FOOTER //
// CourseCalendar.vue?2a20e639